import type { ComponentType } from "react";
import { LocationCustomerAssociationsView } from "./LocationCustomerAssociationsView";

export type LocationAssociationKind = "customer";

export interface LocationAssociationPanelProps {
    locationId: string;
    metaDeleted: boolean;
}

export interface LocationAssociationTypeDef {
    kind: LocationAssociationKind;
    label: string;
    description?: string;
    selectable: boolean;
    Panel: ComponentType<LocationAssociationPanelProps>;
}

export const LOCATION_ASSOCIATION_TYPES: LocationAssociationTypeDef[] = [
    {
        kind: "customer",
        label: "Customer",
        description: "Link this location to customers at a site.",
        selectable: true,
        Panel: LocationCustomerAssociationsView,
    },
];

export function getDefaultSelectableAssociationKind(): LocationAssociationKind {
    const first = LOCATION_ASSOCIATION_TYPES.find((t) => t.selectable);
    if (!first) {
        throw new Error("No selectable location association types registered.");
    }
    return first.kind;
}

export function getLocationAssociationTypeDef(
    kind: LocationAssociationKind
): LocationAssociationTypeDef | undefined {
    return LOCATION_ASSOCIATION_TYPES.find((t) => t.kind === kind);
}
